import { ManagementApiService } from './services/management-api.service';
import { Component, ChangeDetectionStrategy, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { SplashScreenService } from './RefModules/_metronic/partials/layout/splash-screen/splash-screen.service';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { EnvironmentService } from './services/environment.service';

@Component({
    selector: 'body[root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
    docApi: string = environment.docApi;
    subscriptionKey: string;
    constructor(
        // private translationService: TranslationService,
        private splashScreenService: SplashScreenService,
        private router: Router,
        // private tableService: TableExtendedService,
        private managementApiService: ManagementApiService,
        private msalService: MsalService,
        private EnvironmentService: EnvironmentService
    ) {
        this.subscriptionKey = this.EnvironmentService.getConfig().subValue;
    }

    ngOnInit() {
        const routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                // clear filtration paginations and others
                // this.tableService.setDefaults();
                // hide splash screen
                this.splashScreenService.hide();

                // scroll to top on every route change
                window.scrollTo(0, 0);

                // to display back the body content
                setTimeout(() => {
                    document.body.classList.add('page-loaded');
                }, 500);
            }
        });
        this.unsubscribe.push(routerSubscription);

        // * handle changes to the access token if user try to alter the token stored in localstorage then this will
        // * handle this and update the replacement the token with new one
        window.addEventListener(
            'storage',
            (event) => {
                if (event.storageArea === localStorage) {
                    if (event.key === 'msal.accessToken') {
                        this.managementApiService.refreshToken().subscribe((res) => {
                            localStorage.setItem('msal.accessToken', res.accessToken);
                        });
                    } else if (event.key == null) {
                        this.msalService.logout(); // * if user has removed all the items from the local sotrage then logout the user
                    }
                }
            },
            false
        );
        this.interceptAjaxRequests();
    }

    // * used to intercept the pdf-viewer (third-party library) http request
    interceptAjaxRequests(): void {
        const originalOpen = XMLHttpRequest.prototype.open;
        // @ts-ignore
        const subscriptionKey: string = this.subscriptionKey;
        XMLHttpRequest.prototype.open = function (method: string, url: string): void {
            let modifiedUrl = url;

            if (url.toString().includes('pas-proxy')) {
                modifiedUrl = modifyUrl(url);
            }
            originalOpen.call(this, method, modifiedUrl, true);
            if (url.toString().includes('pas-proxy')) {
                // ! uncomment this once @Gnan will enable the server token and sub-key functionality
                this.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('msal.accessToken')}`);
                this.setRequestHeader('Ocp-Apim-Subscription-Key', subscriptionKey);
            }
        };

        const modifyUrl = (url: string | URL): string => {
            return `${this.docApi.replace(/\/api\/$/, '')}${url}`;
        };
    }

    ngOnDestroy(): void {
        this.unsubscribe.forEach((sb) => sb.unsubscribe());
    }
}
